import { Injectable } from '@angular/core';
import {ApiRequestService, HttpRequestType} from '../OffService/api-request.service';
import {RequestHandler} from '../OffService/request-handler';
import {SyncService} from '../OffService/sync.service';

@Injectable({
    providedIn: 'root'
})
export class ExcepcionalesApiService {

    public excepcionalesGET: RequestHandler = new RequestHandler();

    constructor(private syncService: SyncService,
        private api: ApiRequestService) {

        this.defineExcepcionalesGET();
    }

    public defineExcepcionalesGET() {
        this.excepcionalesGET
            .fetch(HttpRequestType.GET, 'mg/excepcionales');

        this.api
            .registerRequest(this.excepcionalesGET);

        this.syncService
            .register(this.syncService.baseSyncPolicy(this.excepcionalesGET));
    }
}
